import { z } from 'zod'
import { FirestoreTimestamp } from './utils'

export const Company = z.object({
  name: z.string(),
  logo: z.string().optional(), // URL
  identifier: z.string(),

  // Audit fields
  createdAt: FirestoreTimestamp,
  updatedAt: FirestoreTimestamp,
})

export type Company = z.infer<typeof Company>
